import { PDFDocument, rgb } from "pdf-lib";
import { User } from '../../../types/types';
import fontkit from "@pdf-lib/fontkit";
import { jsPDF } from 'jspdf'
import { autoTable } from 'jspdf-autotable'
import './times-new-roman-normal.js';
import { downloadPdfFileResponse } from "../../../utils/download-pdf";

async function genDocument10(values: any, info: User) {
  const url = '/nimbus-roman.otf'
  const nimbusRomanBytes = await fetch(url).then((res) => res.arrayBuffer());

  const pdfDoc = await PDFDocument.create()
  pdfDoc.registerFontkit(fontkit)
  const nimbusRomanFont = await pdfDoc.embedFont(nimbusRomanBytes)

  const page = pdfDoc.addPage()
  const { width, height } = page.getSize()
  const fontSize = 14

  if(values?.tru?.length){
    const docTable: any = new jsPDF();
    docTable.setFont('times-new-roman', 'normal');
    autoTable(docTable, {
      styles: {
        font: 'times-new-roman',
        fontStyle: 'normal',
      },
      head: [['№', 'Наим.', 'Инвертарный номер','Ед. изм.','Кол-во','Цена, руб.','Сумма, руб.']],
      body:values?.tru?.map((item: any,index: any)=>[+index+1,item?.name,item?.num,item?.edIzmereniya,item?.count,item?.price,+item?.price * +item?.count]),
    })
    const pdfDocTable = await PDFDocument.load(docTable.output('arraybuffer'))
    const copiedDocTablePages = await pdfDoc.copyPages(pdfDocTable, [0])
    const page2 = pdfDoc.addPage(copiedDocTablePages[0])
    const text2 = `                                                                                                          Приложение 1`
    page2.drawText(text2, {
      x: 150,
      maxWidth: width - 50,
      y: height - 20,
      size: 12,
      font: nimbusRomanFont,
      color: rgb(0, 0, 0),
    })
  }
  


  const textAdrees = values.docTitle

  page.drawText(textAdrees, {
    x: width - 200,
    maxWidth: 180,
    y: height - 30,
    size: fontSize,
    font: nimbusRomanFont,
    color: rgb(0, 0, 0),
  })

  page.drawText(values.regdate, {
    x: 50,
    y: height - height / 5,
    size: fontSize,
    font: nimbusRomanFont,
    color: rgb(0, 0, 0),
    
  })
  page.drawText(`Рег. номер: ${values.regnum}`, {
    x: 400,
    y: height - height / 5,
    size: fontSize,
    font: nimbusRomanFont,
    color: rgb(0, 0, 0),
    
  })

  page.drawText("Заявка", {
    x: 260,
    y: height - height / 5 - 30,
    size: fontSize,
    font: nimbusRomanFont,
    color: rgb(0, 0, 0),
    
  })

  const leftText = `
    ${values.regtext}

    
    
    Создал: ${info.lastname} ${info.firstname} ${info.middlename}
    Должность: ${info.position}
    Подразделение: ${info.department}
    Материально ответственное лицо: ${values.dutyface}
  `




  page.drawText(leftText, {
    x: 50,
    y: height - height / 5 - 30 * 2,
    size: fontSize,
    font: nimbusRomanFont,
    color: rgb(0, 0, 0),
    maxWidth: width - 50
    
  })



  const pdfBytes = await pdfDoc.save()
  
  return pdfBytes
}

export default genDocument10;